import React, { useEffect, useState } from "react";
import { trackPromise } from "react-promise-tracker";

import { getVSIFileIcon } from "file-extension-icon-js";

import { Avatar, List, Dropdown, Menu, message } from "antd";

import { getIconesExtensao, validarVisualizar } from "../../services/utils";

import TableHeader from "../Table/Header";
import TablePagination from "../Table/Pagination";

import iconButtonRestaurarSvg from "../../assets/icons/iconButtonRestaurar.svg";
import infoPastaSvg from "../../assets/icons/infoPasta.svg";
import IcTresPontos from "../../assets/icons/iconeTresPontinhos.svg";
import IcLixeiraVazia from "../../assets/icons/iconLixeiraVazia.svg";
import "./styles.scss";

const tabelaColunas = [
  "Nome", 
  "Tamanho",
  "Tipo",
  "Data do descarte",
  "Usuário que inativou",
];

const ListagemLixeira = ({
  data,
  listagemLixeira,
  aumentarItensPorPagina,
  restaurarArquivoPasta,
  removerLixeira,
  incluirPastaSelecionada,
  showModalVisualizar,
  setOrdenacao,
  ordenacao,
}) => {
 
  const [temLista, setTemLista] = useState(null)
  useEffect(() => {
    if (!data?.lista || data?.lista.length === 0) {
      setTemLista(false);
    } else {
      
      setTemLista(true);
    }

  }, [data?.lista]);

  const formatarData = (value) => {
    if (value) {
      const data = new Date(value);
      return data.toLocaleDateString("pt-BR", { timeZone: "UTC" });
    }
  };

  const handleAbrirOuVisualizar = (item) => {
    if (item.tipo == 0) {
      incluirPastaSelecionada(item.id, "pasta");
    } else {
      if (validarVisualizar(item.extensao) !== "nao-suportado") {
        showModalVisualizar(item);
      } else {
        message.warning("Extensão não tem suporte a visualização");
      }
    }
  };

  const preImagemArquivo = (item) => {
    const extensao = item.extensao ?? item.nome.split(".")[1];

    let nomeArquivo =
      !item.nome.includes(".") && extensao != null
        ? `${item.nome}.${extensao}`
        : item.nome;

    if (item.urlPreview) {
      return <img src={item.urlPreview} />;
    } else {
      return <img src={getIconesExtensao(extensao)} />;
    }
  };

  const showMenu = (item) => {
    return (
      <div className="menu">
        <Menu>
          <Menu.Item
            key="1"
            onClick={() =>
              restaurarArquivoPasta(
                item.id,
                item.tipo == 0 ? "pasta" : "arquivo"
              )
            }
            icon={<img src={iconButtonRestaurarSvg} />}
          >
            Restaurar
          </Menu.Item>
        </Menu>
      </div>
    );
  };
  return (
    <>
      <div className="row">
        <table className="table table-borderless col-lg-12">
        {temLista && <tr>
            { tabelaColunas.length > 0 &&
              tabelaColunas.map((coluna, index) => (
                <th
                  onClick={() => { 
                    coluna == "Nome" &&
                      setOrdenacao(
                        ordenacao == "tipo asc, nomeOrdenacao asc" ? "tipo desc, nomeOrdenacao desc" : "tipo asc, nomeOrdenacao asc"
                      );
                    coluna == "Classificação" &&
                      setOrdenacao(
                        ordenacao == "classificacao asc"
                          ? "classificacao desc"
                          : "classificacao asc"
                      );
               
                    coluna == "Tamanho" &&
                      setOrdenacao(
                        ordenacao == "tamanho  asc"
                          ? "tamanho  desc"
                          : "tamanho  asc"
                      );
                    coluna == "Tipo" &&
                      setOrdenacao(
                        ordenacao == "tipo asc" ? "tipo desc" : "tipo asc"
                      );
                    coluna == "Data do descarte" &&
                      setOrdenacao(
                        ordenacao == "dataInativacao asc"
                          ? "dataInativacao desc"
                          : "dataInativacao asc"
                      );
                    coluna == "Usuário que inativou" &&
                      setOrdenacao(
                        ordenacao == "UsuarioQueInativou asc"
                          ? "UsuarioQueInativou desc"
                          : "UsuarioQueInativou asc"
                      );
                  }}
                  style={{ cursor: "pointer" }}
                  key={index}
                >
                  {" "}
                  {coluna}
                  {coluna === "Nome" && ordenacao === "tipo desc, nomeOrdenacao desc" && (
                    <span>&#9650;</span>
                  )}
                  {coluna === "Nome" && ordenacao === "tipo asc, nomeOrdenacao asc" && (
                    <span>&#9660;</span>
                  )}
                  {coluna === "Classificação" &&
                    ordenacao === "classificacao desc" && <span>&#9650;</span>}
                  {coluna === "Classificação" &&
                    ordenacao === "classificacao asc" && <span>&#9660;</span>}
             
                  {coluna === "Tamanho" &&
                    ordenacao === "tamanho  desc" && (
                      <span>&#9650;</span>
                    )}
                  {coluna === "Tamanho" &&
                    ordenacao === "tamanho  asc" && <span>&#9660;</span>}
                  {coluna === "Tipo" && ordenacao === "tipo desc" && (
                    <span>&#9650;</span>
                  )}
                  {coluna === "Tipo" && ordenacao === "tipo asc" && (
                    <span>&#9660;</span>
                  )}
                  {coluna === "Data do descarte" &&
                    ordenacao === "dataInativacao desc" && <span>&#9650;</span>}
                  {coluna === "Data do descarte" &&
                    ordenacao === "dataInativacao asc" && <span>&#9660;</span>}
                  {coluna === "Usuário que inativou" && ordenacao === "UsuarioQueInativou desc" && (
                    <span>&#9650;</span>
                  )}
                  {coluna === "Usuário que inativou" && ordenacao === "UsuarioQueInativou asc" && (
                    <span>&#9660;</span>
                  )}
                </th>
              ))}
          </tr>}

        
          <tbody>
       
            {data?.lista &&
              data?.lista?.map((item, index) => (
                <tr>
                  <td onClick={() => handleAbrirOuVisualizar(item)}>
                    <span className="coluna-nome">
                      {item.tipo == 0 ? (
                        <img src={infoPastaSvg} />
                      ) : (
                        preImagemArquivo(item)
                      )}
                      <span>{item.nome}</span>
                    </span>
                  </td>
                
                  <td onClick={() => handleAbrirOuVisualizar(item)}>
                    {" "}
                    {item.tamanho != 0 ? item.tamanho : " - "}{" "}
                  </td>
                  <td onClick={() => handleAbrirOuVisualizar(item)}>
                    {" "}
                    {item.tipo == 0 ? "Pasta" : item.extensao}{" "}
                  </td>
                  <td onClick={() => handleAbrirOuVisualizar(item)}>
                    {" "}
                    {formatarData(item.dataInativacao)}{" "}
                  </td>
                  <td onClick={() => handleAbrirOuVisualizar(item)}>
                    {" "}
                    {item.usuarioQueInativou}{" "}
                  </td>
                  <td className="text-right">
                    <List.Item className="list-item">
                      <Dropdown.Button
                        trigger={["click"]}
                        className="button-list"
                        placement="bottomLeft"
                        icon={<img src={IcTresPontos} alt="Ícone" />}
                        overlay={() => showMenu(item)}
                      ></Dropdown.Button>
                    </List.Item>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
        {(!data?.lista || data?.lista.length === 0) && (
              <div className="posicaoLixeira">
                <img src={IcLixeiraVazia} style={{width: 180, height: 180}}/>
                  <span className="lixeiraVazia-texto">A lixeira está vazia</span>
              </div>
            )}
      </div>
      <TablePagination
        data={data}
        changePage={listagemLixeira}
        changeItensPerPage={aumentarItensPorPagina}
      />
      <div className="row d-flex justify-content-center">
        {data?.lista && data?.lista.length > 0 ? (
          <button
            type="submit"
            className="btn-aplicar mb-5"
            onClick={() => removerLixeira()}
          >
            Apagar Lixeira
          </button>
        ) : null}
      </div>
    </>
  );
};

export default ListagemLixeira;
